import Page from "../../components/Page";
import useConclusionPage from "./hooks/useConclusionPage";

const ConclusionPage = () => {
  const page = useConclusionPage();
  return <Page {...page} />;
};

export default ConclusionPage;
